<template>
	<v-dialog v-model="dialog" max-width="600">
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="secondary" class="ml-2" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-list-box-outline</v-icon>
				過去の棚卸しを表示
			</v-btn>
		</template>

		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white">
					過去の棚卸しを表示
				</v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
				<p>表示したい月を選択してください</p>
				<v-row no-gutters class="mt-4">
					<v-col class="px-1" cols="6">
						<v-combobox
							v-model="selectedYear"
							:rules="[rules.required]"
							dense
							outlined
							:items="years"
						>
							<template v-slot:append-outer>年</template>
						</v-combobox>
					</v-col>
					<v-col class="px-1" cols="6">
						<v-combobox
							v-model="selectedMonth"
							:rules="[rules.required]"
							dense
							outlined
							:items="months"
						>
							<template v-slot:append-outer>月</template>
						</v-combobox>
					</v-col>
				</v-row>
			</div>
			<v-card-actions>
				<v-row no-gutters>
					<v-col sm="2" cols="0" />
					<v-col sm="8" cols="12" class="text-center">
						<v-btn color="secondary" @click="fetchInventory">
							<v-icon class="mr-1">mdi-list-box-outline</v-icon>
							表示する
						</v-btn>
					</v-col>
					<v-col sm="2" cols="0" class="text-right">
						<v-btn v-if="!$vuetify.breakpoint.xs" color="grey darken-1" text @click="closeDialog">
							キャンセル
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import rules from "../../../helper/rules"

export default {
	props: {
		month: {
			type: Number,
			required: false,
		},
		year: {
			type: Number,
			required: false,
		},
	},
	data() {
		return {
			selectedMonth: this.month,
			selectedYear: this.year,
			dialog: false,
			rules,
		}
	},
	methods: {
		fetchInventory() {
			this.$emit("fetch-inventory", { month: this.selectedMonth, year: this.selectedYear })
			this.closeDialog()
		},
		closeDialog() {
			this.dialog = false
		},
	},
	computed: {
		years() {
			const thisYear = new Date().getFullYear()
			const endYear = 1900
			const years = [...Array(thisYear - endYear + 1)].map((_, i) => thisYear - i)
			return years
		},
		months() {
			const months = [...Array(12)].map((_, i) => i + 1)
			return months
		},
	},
	watch: {
		month(val) {
			this.selectedMonth = val
		},
		year(val) {
			this.selectedYear = val
		},
	},
}
</script>

<style lang="scss" scoped>
span {
	white-space: pre-wrap;
}
</style>
